// extracted by mini-css-extract-plugin
module.exports = {"Section":"Section-module--Section--xbRLm","padded":"Section-module--padded--2AenH"};